import { render } from "./HomeCategoriesList.vue?vue&type=template&id=0e0fe826"
import script from "./HomeCategoriesList.vue?vue&type=script&lang=js"
export * from "./HomeCategoriesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__